<app-skeleton *ngIf="loading" variant="text" [count]="6"
  label="Carregando o disparo de voz" data-testid="broadcast-call-loading"></app-skeleton>

<div *ngIf="!loading && broadcast">
  <header class="page-head" data-testid="edit-broadcast-call-section">
    <div class="page-head__identity">
      <span class="page-head__icon"><i class="fa fa-pencil"></i></span>
      <div>
        <h1 class="page-head__title">Editar Broadcast: {{ broadcast.name }}</h1>
        <p class="page-head__subtitle">
          <span class="m8v-status-pill m8v-status-pill--sm" [ngClass]="'m8v-status-pill--' + statusTone" data-testid="edit-broadcast-call-status">
            <span class="dot"></span>{{ statusLabel }}
          </span>
          · criado em {{ brasiliaIso(broadcast.created_at) | date : 'dd/MM/yyyy, H:mm' : '-0300' }}
        </p>
      </div>
    </div>
    <div class="page-head__actions">
      <button type="button" class="sf-btn sf-btn--secondary sf-btn--pill" (click)="cancel()" data-testid="btn-back">
        <i class="fa fa-chevron-left"></i> Voltar
      </button>
    </div>
  </header>

  <div *ngIf="!canEdit" class="alert alert-warning call-notice" role="alert" data-testid="edit-locked-notice">
    <i class="fa fa-exclamation-triangle"></i>
    <span>
      <strong>Broadcast não pode ser editado nesse status.</strong>
      Concluídos e cancelados ficam só para consulta; crie um novo broadcast se precisar repetir.
    </span>
  </div>

  <div class="sf-card">
    <form [formGroup]="form" (ngSubmit)="submit()">

      <div class="field-grid">
        <div class="field" style="grid-column: 1 / -1">
          <label for="bcName">Nome do Broadcast <span class="text-danger">*</span></label>
          <input
            id="bcName"
            type="text"
            class="form-control"
            formControlName="name"
            [maxlength]="nameMax"
            placeholder="Ex: Campanha de Agosto"
            data-testid="input-name"
          />
          <span class="field-hint">De {{ nameMin }} a {{ nameMax }} caracteres.</span>
        </div>

        <div class="field" style="grid-column: 1 / -1">
          <label>Áudio de Ligação <span class="text-danger">*</span></label>
          <app-skeleton *ngIf="loadingAudios" variant="text" [count]="1"
            label="Carregando os áudios" data-testid="audios-loading"></app-skeleton>
          <app-search-select
            *ngIf="!loadingAudios"
            formControlName="audioId"
            [options]="audioOptions"
            placeholder="Selecione um áudio"
            searchPlaceholder="Pesquisar áudio…"
            emptyText="Nenhum áudio encontrado"
            noun="áudios"
            testId="edit-broadcast-call-audio"
          ></app-search-select>
        </div>

        <div class="field">
          <label for="bcMaxAttempts">Número máximo de tentativas ({{ attemptsMin }}-{{ attemptsMax }})</label>
          <select id="bcMaxAttempts" class="form-select" formControlName="maxAttempts" data-testid="input-attempts">
            <option *ngFor="let n of attemptsOptions" [value]="n">{{ n }} {{ n === 1 ? 'tentativa' : 'tentativas' }}</option>
          </select>
        </div>

        <div class="field">
          <label for="bcRetryInterval">Intervalo entre tentativas (minutos)</label>
          <input
            id="bcRetryInterval"
            type="number"
            class="form-control"
            formControlName="retryIntervalMinutes"
            [min]="intervalMin"
            [max]="intervalMax"
            placeholder="Ex: 30"
            data-testid="input-interval"
          />
          <span class="field-hint">De {{ intervalMin }} a {{ intervalMax }} minutos.</span>
        </div>
      </div>

      <h6 class="section-label mt-4">Agendamento</h6>
      <app-send-when
        [window]="effectiveWindowCall"
        [sendNow]="sendNow"
        (sendNowChange)="setSendNow($event)"
        testId="edit-schedule"
        [class.m8v-locked]="!canEdit"
        [attr.aria-disabled]="!canEdit ? true : null"
      >
        <div class="field-grid">
          <div class="field">
            <label>Data e Hora de Início <span class="text-danger">*</span></label>
            <app-window-datetime-picker
              formControlName="scheduledDate"
              [window]="effectiveWindowCall"
              testId="edit-dt-start"
            ></app-window-datetime-picker>
          </div>
          <div class="field">
            <label>Data e Hora Final <span class="text-danger">*</span></label>
            <app-window-datetime-picker
              formControlName="scheduledEndDate"
              [window]="effectiveWindowCall"
              testId="edit-dt-end"
            ></app-window-datetime-picker>
          </div>
        </div>
      </app-send-when>

      <ng-container *ngTemplateOutlet="windowNotice"></ng-container>

      <hr class="mt-4" />
      <h6 class="mt-3">Integração (opcional)</h6>
      <div class="field">
        <label for="bcPostbackUrl">URL de Postback</label>
        <input
          id="bcPostbackUrl"
          type="url"
          class="form-control"
          formControlName="postbackUrl"
          placeholder="https://seu-endpoint.com/callback"
          data-testid="input-postback"
        />
        <span
          class="field-error"
          *ngIf="postbackUrlControl?.value && postbackUrlControl?.errors?.['invalidUrl']"
        >
          <i class="fa fa-exclamation-circle"></i> URL inválida. Use um endereço HTTP ou HTTPS completo.
        </span>
      </div>

      <div class="d-flex justify-content-between mt-4">
        <button type="button" class="sf-btn sf-btn--secondary" (click)="cancel()" data-testid="btn-cancel">
          <i class="fa fa-arrow-left"></i> Cancelar
        </button>
        <button
          type="submit"
          class="sf-btn sf-btn--primary"
          [disabled]="!canEdit || form.invalid"
          [appLoadingButton]="isSaving"
          data-testid="btn-save"
        >
          <i class="fa fa-save"></i>
          Salvar Alterações
        </button>
      </div>

    </form>
  </div>
</div>

<!-- Aviso da janela de ligação: SEMPRE montado a partir de `windowCall` (vem de config, nunca hardcoded). -->
<ng-template #windowNotice>
  <div class="alert alert-warning call-notice mb-0" role="note" *ngIf="windowCall" data-testid="window-notice">
    <i class="fa fa-moon-o"></i>
    <span>
      <strong>Atenção:</strong> ligações ficam bloqueadas entre {{ windowCall.stop }} e {{ windowCall.start }}
      (horário de Brasília). O que cair fora da janela é adiado para o próximo horário permitido.
    </span>
  </div>
</ng-template>
